import { NotFoundException } from "../customExceptions";
import Loader from "@material-ui/core/CircularProgress";
import trimString from "../helpers/trimString";
import { useGetAudience } from "../queries/audiences";
import { ENTITY } from "../constants";

export const AudienceBreadcrumb = ({ match }) => {
  // Entity
  const { AUDIENCE } = ENTITY;

    const {
      data: audience,
      isLoading,
      isError,
      error,
    } = useGetAudience(match.params.audienceId);
  
    if (isLoading) {
      //return <span>Loading...</span>;
      return <Loader color="primary" size={18} sx={{ mr: 1 }} />;
    }
  
    if (isError && error instanceof NotFoundException) {
      return <span>Not found</span>;
    }
  
    if (audience) {
      return <span>{trimString(audience[AUDIENCE.nameField], 20)}</span>;
    }
  
    return null;
  };